import React from 'react';
const ReportTemplateTitle = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, "Configure Full R&D Report");
};
export default ReportTemplateTitle;